import type { ReactElement } from 'react'
import { DashTable } from '../../dash-blocks/dash-table/DashTable'
import {
  type DashTableDatum,
  type DashTableBaseFiltersType,
} from '../../dash-blocks/dash-table/utils/dashTable.types'
import { type UseDashTableBehaviour } from '../../dash-blocks/dash-table/utils/dashTable.utils'
import { useTableBehaviour } from './utils/table.hooks'

export function Table<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  TData extends DashTableDatum = any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  TFilters extends DashTableBaseFiltersType = any
>(props: UseDashTableBehaviour<TData, TFilters>): ReactElement {
  const behaviour = useTableBehaviour()

  return <DashTable<TData, TFilters> {...props} {...behaviour} />
}
